<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Expenditure Summary</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>

        <v-row>

      <!-- datepicker 2 -->
      <v-col cols="12" xs="12" sm="12" md="3">
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              dense
              outlined
              single-line
              v-model="record.StartDate"
              label="From"
              prepend-icon="mdi-calendar-month"
              v-on="on"
              readonly
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="record.StartDate"
            @input="menu1 = false"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <!-- datepicker 2 -->
      <v-col xs="12" sm="12" md="3">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              dense
              outlined
              single-line
              v-model="record.EndDate"
              label="To"
              prepend-icon="mdi-calendar-month"
              v-on="on"
              readonly
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="record.EndDate"
            @input="menu2 = false"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="3">
        <v-autocomplete
          autocomplete="off"
          hide-details
          dense
          outlined
          v-model="record.CategoryId"
          :items="categories"
          label="Category"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="3">
        <v-autocomplete
          autocomplete="off"
          hide-details
          dense
          outlined
          v-model="record.AccountId"
          :items="accounts"
          label="Account"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>


      <v-col cols="3">
        <v-autocomplete
          autocomplete="off"
          dense
          outlined
          v-model="record.StaffId"
          :items="employees"
          label="Staff"
          item-text="name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="9">
        <v-btn class="float-right" color="primary" :loading="$store.state.loader" @click="getReport"
          ><v-icon left>mdi-list-box-outline</v-icon>Generate Report</v-btn
        >
      </v-col>
    </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12" class="subtitle-2 text--primary">
            <span
              >Total: {{ TotalExpenses | currency }}</span
            >
            <!-- start of table -->
            <v-data-table
              :mobile-breakpoint="0"
              :headers="headers"
              :items="expenses"
              :search="search"
            >
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" text :to="`/expenses/${item.id}`" icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    menu1: false,
    menu2: false,
    employees: [],
    categories: [],
    accounts: [],
    record: {},
    headers: [
      { text: "Category", value: "category.Name" },
      { text: "Amount", value: "Amount" },
      { text: "Paid Via", value: "account.Name" },
      { text: "Description", value: "narration" },
      { text: "Staff", value: "staff.name" },
      { text: "Date", value: "DocDate" },
    ],
    expenses: [],
    TotalExpenses: 0,
  }),
  methods: {
    getReport() {
      const url = "/expenditure-report";
      const data = {
        StartDate: this.record.StartDate,
        EndDate: this.record.EndDate,
        CategoryId: this.record.CategoryId,
        AccountId: this.record.AccountId,
        StaffId: this.record.StaffId
      };

      const self = this;
      this.$store
        .dispatch("post", { data, url })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.expenses = res.ResponseData.expenses;
            self.TotalExpenses = res.ResponseData.TotalExpenses;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    expAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/expenditure-accounts`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.categories= res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getBankAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.accounts= res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.employees = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([this.expAccounts(), this.getUsers(), this.getBankAccounts()]);
  },
};
</script>